export default __webpack_public_path__ + "static/media/cohort-document-empty.cf6296bb.svg";